/**
 * Teatros exentos del comportamiento por defecto de `ocultar_abonos`.
 *
 * Por defecto, los teatros con `manager.ocultar_abonos` activo y `tipo === 2`
 * (teatro) ven el botón "Venta de abonos" del sidebar OCULTO y, si entran por
 * URL directa, el guard del router los redirige a `back.events.index` (este
 * es el comportamiento introducido en #2531). Esto se decidió porque el
 * flag estaba pensado para esconder la venta al público y aterrizar en una
 * vista vacía se sentía roto.
 *
 * Sin embargo, hay tres teatros donde el backoffice de "Venta de abonos"
 * SÍ es necesario aunque la venta al público esté oculta (informes de ventas
 * pasadas, configuración de butacas, gestión de abonados existentes, etc.).
 * Para ellos se ignora el comportamiento por defecto y se les muestra siempre
 * la entrada al backoffice.
 *
 * Esta es una excepción operativa y temporal. El patrón correcto sería que
 * `ocultar_abonos` fuese estrictamente front-only y no afectase al backoffice;
 * mientras esa migración no se hace globalmente, esta allowlist mantiene la
 * compatibilidad para los tres teatros que ya están adaptados al cambio.
 *
 * Identifica al teatro por `hash_teatro` (el mismo campo string que
 * `localStorage.getItem('hash_teatro')` y `config.data.hash_teatro`).
 */
export const TEATROS_CON_VENTA_EXENTA = Object.freeze([
    'gixfZw6Mz7gY1WULvX12',
    'bqtbahP9ObVdqbo7YeBP',
    'XcFhuzamdMXbBfNonZkC',
]);

/**
 * Devuelve true si el teatro identificado por `hash_teatro` debe seguir viendo
 * el backoffice de "Venta de abonos" aunque tenga `ocultar_abonos` activo.
 *
 * @param {string|null|undefined} hash_teatro
 * @returns {boolean}
 */
export function esTeatroConVentaExenta(hash_teatro) {
    if (!hash_teatro) return false;
    return TEATROS_CON_VENTA_EXENTA.includes(hash_teatro);
}
